import styled from 'styled-components';

export default styled.p`
  font-family: var(--google-sora-cdn);
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  color: var(--text-color);
  margin: 0;
  white-space: pre-wrap;

  strong {
    font-weight: inherit;
    text-decoration: underline;
    text-decoration-skip-ink: none;
  }
`;
